import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectFieldOption } from '@sdbn/common';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';
import { TransportType } from '../../../common/model/transport.model';

@Component({
  selector: 'yard-transport-type-condition-editor',
  standalone: false,
  templateUrl: './transport-type-condition-editor.component.html',
  styleUrl: './transport-type-condition-editor.component.scss',
})
export class TransportTypeConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    value: new FormControl(null, [])
  });

  selectFieldOptions: Array<SelectFieldOption>;

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.value;
    });

    let selectFieldOptions = new Array<SelectFieldOption>();
    for (const key of Object.keys(TransportType)) {
      selectFieldOptions.push(new SelectFieldOption({ labelDictionaryKey: 'tmc-yard.entity.transport.transport-type.' + TransportType[key], value: TransportType[key]}));
    }
    this.selectFieldOptions = selectFieldOptions;

  }

}
